import { Modal } from "antd";

const CustomModal = ({
  open,
  onCancel,
  children,
  width,
  closeIcon = false,
  className,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={false}
      width={width}
      closeIcon={closeIcon}
      maskClosable={false}
      bodyStyle={{ padding: 0 }}
      className={className}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
